import { ChangeDetectionStrategy, Component, ErrorHandler, Input, OnDestroy, OnInit, signal } from '@angular/core'
import { FieldTree, form } from '@angular/forms/signals'
import { MatDialog } from '@angular/material/dialog'
import { Router } from '@angular/router'

import { KirjautunutKayttajaService } from './_angular/service/kirjautunut-kayttaja.service'
import { LadataanService } from './_jaettu-angular/service/ladataan.service'

import { VaihdaKieliDialog, VaihdaKieliDialogData } from './vaihda-kieli.dialog'

import { AsiakasService } from './_angular/service/asiakas/asiakas.service'
import { KirjanpitoService } from './_angular/service/kirjanpito/kirjanpito.service'

import { Asiakas, ListausAsiakas } from './_jaettu-lemonator/model/asiakas'
import { KirjanpitajaTiimiAvaimet, Kirjanpitaja, KirjanpitajanNimitiedot, KirjanpitajanTiimikokonaisuus } from './_jaettu-lemonator/model/kirjanpitaja'
import { AsiakasJaettuService } from './_jaettu-lemonator/service/asiakas-jaettu.service'

import { KirjanpitajanRooli } from '@lemon/core-firebase/lemonator/model/kirjanpitaja'
import { SopimusPalvelupaketti } from '@lemon/core-firebase/model/kayttaja'
import { LemonatorAlavalikko, NakymaOikeusService } from './_angular/service/nakyma-oikeus.service'
import { LemonatorNakyma } from './_jaettu-lemonator/model/lemonator-nakyma'
import { AsiakkaanSopimuskausiService } from './_jaettu-lemonator/service/sopimuskausi.service'

import { KirjanpitajaService } from './_angular/service/kirjanpitaja/kirjanpitaja.service'

import { AsiakkaatDataSourceStateService } from './asiakkaat/listaus/asiakkaat.datasource.service'

import { arvonMuutokset, asetaArvo } from './_jaettu-angular/_lomakkeet/arvon-muutokset'
import { Aikakone } from './_jaettu-angular/service/aikakone'

import { BehaviorSubject, Observable, Subject, combineLatest, firstValueFrom, of as observableOf } from 'rxjs'

import { DateService } from '@lemon/core/service/date.service'
import { Tilintarkastaja } from 'app/_jaettu-lemonator/model/tilintarkastaja'
import { map, switchMap, takeUntil } from 'rxjs/operators'
import { environment } from '../environments/environment'
import { AsiakasTyojonoLoadingService } from './_angular/service/asiakas/asiakas-tyojono-loading.service'
import { FirebaseLemonaid, FirebaseLemonator } from './_angular/service/firebase-lemonator.service'
import { VersionTarkistusPalvelu } from './_angular/service/version-tarkistus.palvelu'
import { lemonShare } from './_jaettu-angular/_rxjs/lemon-share.operator'
import { IlmoitinIntegrationEntity } from './_jaettu-lemonator/model/kirjanpito'
import { KirjanpitajanTiimiService } from './_jaettu-lemonator/service/kirjanpitajan-tiimi.service'

interface ValikkoLomake {
  kirjanpitaja: string | null
  aikakone: Date | null
}

@Component({
  selector: 'app-menu',
  templateUrl: './app-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppMenuComponent implements OnInit, OnDestroy {
  private _ngUnsubscribe: Subject<void> = new Subject<void>()
  private _url: string

  // @Output() vasemmanValikonSulkupyynto: EventEmitter<void> = new EventEmitter()
  // @Output() vasemmanValikonSulkupyyntoOma: EventEmitter<'avaa' | 'sulje'> = new EventEmitter()

  @Input() naytaSuper = false
  @Input() naytaYberSuper = false
  @Input() naytaSales = false
  @Input() naytaLisaaAsiakas = false
  @Input() nykyinenAsiakas: Asiakas
  @Input()
  set url(url: string) {
    this._url = url || ''
    if (
      this._url.indexOf('/laskutus') > -1 ||
      this._url.indexOf('/asiakastiedot') > -1 ||
      this._url.indexOf('/kirjanpitotiedot') > -1 ||
      this._url.indexOf('/tuntemistiedot') > -1 ||
      this._url.indexOf('/holvi-import') > -1 ||
      this._url.indexOf('/sisainen-arkisto') > -1 ||
      (this._url.indexOf('/sopimukset') > -1 && this._url.indexOf('/yllapito') === -1) ||
      this._url.indexOf('/ajastetut-tyot') > -1 ||
      this._url.indexOf('/lataus-tyot') > -1 ||
      this._url.indexOf('/tuonnit') > -1 ||
      this._url.indexOf('/alkusaldo-import') > -1 ||
      this._url.indexOf('/tuote-import') > -1
    ) {
      this.valittuAlavalikko = 'asetukset'
    } else if (this._url.indexOf('/kirjanpito') > -1) {
      this.valittuAlavalikko = 'kirjanpito'
    } else if (
      this._url.indexOf('/tositteet/selaa') > -1 ||
      this._url.indexOf('/laskut/selaa') > -1 ||
      this._url.indexOf('/lasku-asiakkaat/selaa') > -1 ||
      this._url.indexOf('/tuotteet/selaa') > -1 ||
      this._url.indexOf('/ostolaskut/selaa') > -1 ||
      this._url.indexOf('/toimittajat/selaa') > -1 ||
      this._url.indexOf('/laskut/toistuvat') > -1 ||
      this._url.indexOf('/tositteet/lataa') > -1 ||
      this._url.indexOf('/kayttajat') > -1 ||
      this._url.indexOf('/maksutavat') > -1 ||
      this._url.indexOf('/kirjanpidon-ulkopuoliset-vahennykset') > -1 ||
      this._url.indexOf('/laskuasetukset') > -1 ||
      this._url.indexOf('/aineiston-lataus') > -1
    ) {
      this.valittuAlavalikko = 'lemonaid'
    } else if (
      this._url.indexOf('/pankkiyhteydet') > -1 ||
      this._url.indexOf('/tilitapahtumat') > -1 ||
      this._url.indexOf('/yllapito/apixlaskut') > -1 ||
      this._url.indexOf('/veronmaksu') > -1 ||
      this._url.indexOf('/lahetykset') > -1 ||
      this._url.indexOf('/paivasaldot') > -1 ||
      this._url.indexOf('/ytj-tiedot') > -1 ||
      this._url.indexOf('/alusta-kirjanpito') > -1 ||
      this._url.indexOf('/yllapito/massamuikkarit') > -1 ||
      this._url.indexOf('/holvi-tilitapahtumat') > -1 ||
      this._url.indexOf('/yhteisomyynti-ilmoitukset') > -1 ||
      this._url.indexOf('/yllapito/logit') > -1
    ) {
      this.valittuAlavalikko = 'yllapito'
    } else if (
      this._url.indexOf('/zen') > -1 ||
      this._url.indexOf('/asiakkaat') > -1 ||
      this._url.indexOf('/jaettavat-asiakkaat') > -1 ||
      this._url.indexOf('/tilastot') > -1 ||
      this._url.indexOf('/tiimitilastot') > -1 ||
      this._url.indexOf('/kirjanpitajan-asetukset') > -1 ||
      this._url.indexOf('/it-tyopoyta') > -1 ||
      this._url === '/' ||
      this._url === ''
    ) {
      this.valittuAlavalikko = 'koti'
    } else {
      this.valittuAlavalikko = 'none'
    }
    // if (this._url.indexOf('/kirjanpito') > -1) {
    //   setTimeout(() => {
    //     this._ngZone.run(() => {
    //       this.vasemmanValikonSulkupyyntoOma.next('sulje')
    //     })
    //   }, 5)
    // } else {
    //   setTimeout(() => {
    //     this._ngZone.run(() => {
    //       this.vasemmanValikonSulkupyyntoOma.next('avaa')
    //     })
    //   }, 5)
    // }
  }
  get url(): string {
    return this._url
  }

  lomake: FieldTree<ValikkoLomake>

  valittuAlavalikko: LemonatorAlavalikko | 'none' | 'koti' = 'lemonaid'
  kirjanpitajaObservable: Observable<Kirjanpitaja>
  valittavissaOlevatKirjanpitajatObservable: Observable<KirjanpitajanNimitiedot[]>
  naytaPoistuneetKirjanpitajatSubject: BehaviorSubject<boolean> = new BehaviorSubject(false)
  naytaHolviObservable: Observable<boolean>
  naytaItTyopoytaObservable: Observable<boolean>
  version: string
  readonly paaversioJulkaistu = signal('')

  lahettamattomatVeroIlmoituksetMaaraObservable: Observable<{ maara: number }>
  lahettamattomatAlvIlmoituksetMaaraObservable: Observable<{ maara: number }>
  lahettamattomatPrhRekisteroinnitMaaraObservable: Observable<{ maara: number }>
  hylatytTilintarkastajaTunnuksetMaaraObservable: Observable<{ maara: number }>

  tyojonolatauksetKeskenObservable: Observable<boolean>

  naytaYllapitoMassamuikkaritObservable: Observable<boolean>
  naytaYllapitoPaatilikarttaObservable: Observable<boolean>
  naytaYllapitoLlmTestausObservable: Observable<boolean>
  naytaYllapitoYberObservable: Observable<boolean>
  naytaYllapitoMoniyritysObservable: Observable<boolean>
  sallitutNakymatObservable: Observable<Partial<Record<LemonatorNakyma, true>>>

  naytaTyolistaObservable: Observable<boolean>
  naytaTyolistaFivaldiObservable: Observable<boolean>
  naytaTyolistaKasvuObservable: Observable<boolean>

  // onkoKirjaamattomiaTuntejaObservable: Observable<boolean>
  // saldotPaivitettyObservable: Observable<string>

  // public setupCookies() {
  //   this._ladataanService.aloitaLataaminen()
  //   this._auth.auth.currentUser.getIdToken().then(lemonatorToken => {
  //     const payload: { idToken: string } = {
  //       idToken: lemonatorToken
  //     }
  //     return this._httpService.postJsonGetJsonWithCredentials<{ status: 'success' }, { idToken: string }>('/api/1/autentikointi/alustaKeksi', payload, LEMONATOR_HTTPS_API)
  //   }).then(() => {
  //     this._ladataanService.lopetaLataaminen()
  //   }).catch(err => {
  //     this._errorHandler.handleError(err)
  //     this._ladataanService.lopetaLataaminen()
  //   })
  // }

  // public setupCookiesDev() {
  //   this._ladataanService.aloitaLataaminen()
  //   this._auth.auth.currentUser.getIdToken().then(lemonatorToken => {
  //     const payload: { idToken: string } = {
  //       idToken: lemonatorToken
  //     }
  //     return this._httpService.postJsonGetJsonWithCredentials<{ status: 'success' }, { idToken: string }>('/api/1/autentikointi/alustaKeksiDev', payload, LEMONATOR_HTTPS_API)
  //   }).then(() => {
  //     this._ladataanService.lopetaLataaminen()
  //   }).catch(err => {
  //     this._errorHandler.handleError(err)
  //     this._ladataanService.lopetaLataaminen()
  //   })
  // }

  constructor(
    private _errorHandler: ErrorHandler,
    private _kirjautunutKayttajaService: KirjautunutKayttajaService,
    private _router: Router,
    private _dialog: MatDialog,
    private _ladataanService: LadataanService,
    private _asiakasService: AsiakasService,
    private _asiakasJaettuService: AsiakasJaettuService,
    private _kirjanpitajaService: KirjanpitajaService,
    private _kirjanpitajanTiimiService: KirjanpitajanTiimiService,
    private _asiakasDataSourceStateService: AsiakkaatDataSourceStateService,
    private _kirjanpitoService: KirjanpitoService,
    private _aikakone: Aikakone,
    private _firebaseLemonator: FirebaseLemonator,
    private _firebaseLemonaid: FirebaseLemonaid,
    private _dateService: DateService,
    private _sopimuskausiService: AsiakkaanSopimuskausiService,
    private _asiakasTyojonoLoadingService: AsiakasTyojonoLoadingService,
    private _versionTarkistusPalvelu: VersionTarkistusPalvelu,
    private _nakymaOikeusService: NakymaOikeusService,
  ) {
    this.kirjanpitajaObservable = this._kirjanpitajaService.kirjautuneenKayttajanKirjanpitajaObservable

    // this.saldotPaivitettyObservable = _firestore.doc<OmaveroSaldokoosteenAikaleima>('omavero-saldot-kooste/viimeisin-aikaleima').valueChanges().pipe(
    //   map(doku => {
    //     if (doku) {
    //       const asDate = this._dateService.timestampToDate(doku.aikaleima)
    //       return this._dateService.muotoilePaivaJaAikaDate(asDate, 'fi')
    //     }
    //     return ''
    //   })
    // )

    this.lahettamattomatPrhRekisteroinnitMaaraObservable = this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable.pipe(
      switchMap(kp => {
        if (!kp?.uid) {
          return observableOf({ maara: 0 })
        }
        return this._firebaseLemonator
          .firestoreCollectionGroup<IlmoitinIntegrationEntity>('kirjanpito-prh-rekisteroinnit')
          .where('lahetetty', '==', null)
          .listenSnapshots()
          .pipe(
            map(lahettamattomatQuerySnapshot => {
              return { maara: lahettamattomatQuerySnapshot.length }
            }),
          )
      }),
    )

    this.lahettamattomatAlvIlmoituksetMaaraObservable = this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable.pipe(
      switchMap(kp => {
        if (!kp?.uid) {
          return observableOf({ maara: 0 })
        }
        return this._firebaseLemonator
          .firestoreCollectionGroup<IlmoitinIntegrationEntity>('kirjanpito-alvilmoitukset')
          .where('lahetetty', '==', null)
          .listenSnapshots()
          .pipe(
            map(lahettamattomatQuerySnapshot => {
              return { maara: lahettamattomatQuerySnapshot.length }
            }),
          )
      }),
    )

    this.lahettamattomatVeroIlmoituksetMaaraObservable = this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable.pipe(
      switchMap(kp => {
        if (!kp?.uid) {
          return observableOf({ maara: 0 })
        }
        return this._firebaseLemonator
          .firestoreCollectionGroup<IlmoitinIntegrationEntity>('kirjanpito-veroilmoitus-final')
          .where('lahetetty', '==', null)
          .listenSnapshots()
          .pipe(
            map(lahettamattomatQuerySnapshot => {
              return { maara: lahettamattomatQuerySnapshot.length }
            }),
          )
      }),
    )

    this.hylatytTilintarkastajaTunnuksetMaaraObservable = this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable.pipe(
      switchMap(kp => {
        if (!kp?.uid) {
          return observableOf({ maara: 0 })
        }
        return this._firebaseLemonator
          .firestoreCollection<Tilintarkastaja>('tilintarkastajat')
          .where('tila', '==', 'hylatty')
          .listenSnapshots()
          .pipe(
            map(lahettamattomatQuerySnapshot => {
              return { maara: lahettamattomatQuerySnapshot.length }
            }),
          )
      }),
    )

    this.tyojonolatauksetKeskenObservable = this._asiakasTyojonoLoadingService.tyojonolatauksetKeskenObservable

    this.naytaYllapitoMassamuikkaritObservable = this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable.pipe(
      switchMap(kirjanpitaja => {
        if (!kirjanpitaja?.uid) {
          return observableOf(false)
        }
        return this._kirjanpitajanTiimiService.onkoKirjanpitajaJossakinTiimissa(
          kirjanpitaja.uid,
          KirjanpitajaTiimiAvaimet.MUUT,
          KirjanpitajaTiimiAvaimet.KAYTTOTUKI,
          KirjanpitajaTiimiAvaimet.IT,
          KirjanpitajaTiimiAvaimet.GENOVA,
        )
      }),
    )

    this.naytaYllapitoPaatilikarttaObservable = this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable.pipe(
      switchMap(kirjanpitaja => {
        if (!kirjanpitaja?.uid) {
          return observableOf(false)
        }
        // Tarja Nieminen
        if (kirjanpitaja.uid === 'cVYOWEOwXxcTRBAxdChEK6IPM3u2') {
          return observableOf(true)
        }
        return this._kirjanpitajanTiimiService.onkoKirjanpitajaJossakinTiimissa(kirjanpitaja.uid, KirjanpitajaTiimiAvaimet.MUUT, KirjanpitajaTiimiAvaimet.KAYTTOTUKI, KirjanpitajaTiimiAvaimet.IT)
      }),
    )

    this.naytaYllapitoLlmTestausObservable = this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable.pipe(
      switchMap(kirjanpitaja => {
        if (!kirjanpitaja?.uid) {
          return observableOf(false)
        }
        return combineLatest([
          this._kirjautunutKayttajaService.kirjanpitajaOnSallittuLlmTestausKayttajaObservable,
          this._kirjanpitajanTiimiService.onkoKirjanpitajaJossakinTiimissa(kirjanpitaja.uid, KirjanpitajaTiimiAvaimet.MUUT, KirjanpitajaTiimiAvaimet.KAYTTOTUKI, KirjanpitajaTiimiAvaimet.IT),
        ]).pipe(map(([sallittu, tiimissa]) => sallittu || tiimissa))
      }),
    )

    this.naytaYllapitoYberObservable = this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable.pipe(
      switchMap(kirjanpitaja => {
        if (!kirjanpitaja?.uid) {
          return observableOf(false)
        }
        return this._kirjanpitajanTiimiService.onkoKirjanpitajaJossakinTiimissa(kirjanpitaja.uid, KirjanpitajaTiimiAvaimet.MUUT, KirjanpitajaTiimiAvaimet.KAYTTOTUKI, KirjanpitajaTiimiAvaimet.IT)
      }),
    )

    this.naytaYllapitoMoniyritysObservable = this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable.pipe(
      switchMap(kirjanpitaja => {
        if (!kirjanpitaja?.uid) {
          return observableOf(false)
        }
        return this._kirjanpitajanTiimiService.onkoKirjanpitajaJossakinTiimissa(kirjanpitaja.uid, KirjanpitajaTiimiAvaimet.KAYTTOTUKI, KirjanpitajaTiimiAvaimet.IT)
      }),
    )

    this.sallitutNakymatObservable = this._nakymaOikeusService.sallitutNakymatObservable

    this.lomake = form(signal<ValikkoLomake>({ kirjanpitaja: null, aikakone: null }))
    arvonMuutokset(this.lomake.kirjanpitaja)
      .pipe(takeUntil(this._ngUnsubscribe))
      .subscribe(value => {
        // this.suljeVasenValikko()
        this._asiakasDataSourceStateService?.rajaaKirjanpitajaAvainObservable?.next(value)
      })
    arvonMuutokset(this.lomake.aikakone)
      .pipe(takeUntil(this._ngUnsubscribe))
      .subscribe(value => {
        this._aikakone.asetaYliajopäivämäärä(value)
      })

    this.version = environment.version
    this._versionTarkistusPalvelu.sovelluksenVersioObservable.pipe(takeUntil(this._ngUnsubscribe)).subscribe(versiotiedot => {
      this.paaversioJulkaistu.set(versiotiedot?.paaversioJulkaistu?.seconds ? this._dateService.muotoile(versiotiedot.paaversioJulkaistu.toDate(), 'w/yyyy') : '')
    })

    // Laske viimeisen 3kk aktiiviset kirjanpitäjät kerran ja cacheta tulos
    const viimeisen3kkAktiivisetKirjanpitajatObservable = this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable.pipe(
      switchMap(async () => {
        const currentNumberDate = this._dateService.currentNumberDate()
        const kolmeKkSitten = this._dateService.lisaaKuukausiaNumero(currentNumberDate, -3)
        const tiimitViimeisen3kk = await this._kirjanpitajanTiimiService.annaTiimitPaivamaaraValille(kolmeKkSitten, currentNumberDate)
        const viimeisen3kkAktiivisetKirjanpitajat: Set<string> = new Set()
        for (const tiimi of tiimitViimeisen3kk) {
          for (const kp of tiimi.esihenkilot) {
            viimeisen3kkAktiivisetKirjanpitajat.add(kp.kirjanpitajaAvain)
          }
          for (const kp of tiimi.jasenet) {
            viimeisen3kkAktiivisetKirjanpitajat.add(kp.kirjanpitajaAvain)
          }
        }
        return viimeisen3kkAktiivisetKirjanpitajat
      }),
    )

    this.valittavissaOlevatKirjanpitajatObservable = combineLatest([
      this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable,
      this._kirjanpitajaService.kirjanpitajienNimitiedotObservable,
      this.naytaPoistuneetKirjanpitajatSubject,
      viimeisen3kkAktiivisetKirjanpitajatObservable,
    ]).pipe(
      switchMap(async ([kirjanpitaja, nimitiedot, naytaPoistuneet, viimeisen3kkAktiivisetKirjanpitajat]) => {
        if (!kirjanpitaja || !nimitiedot?.length) {
          return []
        }

        const sorted = nimitiedot.sort((a, b) => {
          if (a.etunimi !== b.etunimi) {
            return a.etunimi.localeCompare(b.etunimi)
          }
          return a.sukunimi.localeCompare(b.sukunimi)
        })

        const currentNumberDate = this._dateService.currentNumberDate()

        const tiimit = await this._kirjanpitajanTiimiService.annaKirjanpitajanTiimit(kirjanpitaja.uid, currentNumberDate)

        if (
          tiimit.some(
            tiimi =>
              tiimi.tiimi.avain === KirjanpitajaTiimiAvaimet.IT ||
              tiimi.tiimi.avain === KirjanpitajaTiimiAvaimet.KAYTTOTUKI ||
              tiimi.tiimi.avain === KirjanpitajaTiimiAvaimet.MUUT ||
              tiimi.tiimi.avain === KirjanpitajaTiimiAvaimet.GENOVA,
          )
        ) {
          if (naytaPoistuneet) {
            return sorted.filter(nt => nt.avain === kirjanpitaja.uid || !nt.poistettu)
          } else {
            return sorted.filter(nt => nt.avain === kirjanpitaja.uid || (!nt.poistettu && viimeisen3kkAktiivisetKirjanpitajat.has(nt.avain)))
          }
        }

        const [johdetutTiimit, johdetutKokonaisuudet] = await Promise.all([
          this._kirjanpitajanTiimiService.annaTiimitJotaKirjanpitajaVetaa(kirjanpitaja.uid, currentNumberDate),
          this._kirjanpitajanTiimiService.annaKokonaisuudetJotaKirjanpitajaVetaa(kirjanpitaja.uid, currentNumberDate),
        ])

        if (johdetutTiimit.length > 0 || johdetutKokonaisuudet.length > 0) {
          const tiimiKokonaisuudet = await this._kirjanpitajanTiimiService.annaTiimienKokonaisuudet(
            johdetutTiimit.map(tiimi => tiimi.avain),
            currentNumberDate,
          )
          const kaikkiKokonaisuudet = new Set<KirjanpitajanTiimikokonaisuus>([...tiimiKokonaisuudet, ...johdetutKokonaisuudet])
          const kirjapitajatKokonaisuuksienTiimeissa = await this._kirjanpitajanTiimiService.annaTiimikokonaisuuksienKirjanpitajatPaivalleSet(kaikkiKokonaisuudet, currentNumberDate)
          if (naytaPoistuneet) {
            return sorted.filter(nt => {
              if (nt.avain === 'uekRGWgeLqecXk0Gh8el0s85SEt1' && kirjanpitaja.uid === 'nwEYCXNoWBcfLoFl9jTRcX7i9583') {
                // Kovakoodattu poikkeus, Maija Minkkiselle näkyviin 'Poistuneet asiakkaat'
                return true
              }
              return nt.avain === kirjanpitaja.uid || (!nt.poistettu && kirjapitajatKokonaisuuksienTiimeissa.has(nt.avain))
            })
          } else {
            return sorted.filter(nt => nt.avain === kirjanpitaja.uid || (!nt.poistettu && kirjapitajatKokonaisuuksienTiimeissa.has(nt.avain) && viimeisen3kkAktiivisetKirjanpitajat.has(nt.avain)))
          }
        }

        return []

        // if (kirjanpitaja.avain === 'dqUiLNmLRaMNbyNgMhWG1AUmVGI2' || // Valtteri
        //   kirjanpitaja.avain === 'AHiu6xZimwXgxmd3d5vqzbC8ce42' // Jon
        // ) {
        //   this.kirjanpitajienLista = nimitiedot
        //   return
        // }

        // const currentNumberDate = this._dateService.currentNumberDate()
        // const tiimi = await this._kirjanpitajanTiimiService.annaKirjanpitajanEnsimmainenTiimi(kirjanpitaja.avain, currentNumberDate)

        // const tiimitJotaKirjanpitajaVetaa = await this._kirjanpitajanTiimiService.annaTiimitJotaKirjanpitajaVetaa(kirjanpitaja.avain, _dateService.currentNumberDate())

        // if (!tiimitJotaKirjanpitajaVetaa.length) {
        //   this.kirjanpitajienLista = []
        //   return
        // }

        // const jasenetMap: Map<string, true> = new Map()
        // for (const t of tiimitJotaKirjanpitajaVetaa) {
        //   for (const jasen of t.jasenet) {
        //     jasenetMap.set(jasen.kirjanpitajaAvain, true)
        //   }
        // }

        // this.kirjanpitajienLista = nimitiedot.filter(nt => kirjanpitaja.avain === nt.avain || jasenetMap.has(nt.avain))
        // this.kirjanpitajienLista.push({ avain: 'uekRGWgeLqecXk0Gh8el0s85SEt1', etunimi: 'Lopettaneet', sukunimi: 'asiakkaat', }) // AKA Taneli Testinen
      }),
      lemonShare(),
    )

    this.naytaHolviObservable = this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable.pipe(
      map(kirjautunutKayttaja => {
        if (kirjautunutKayttaja && (kirjautunutKayttaja.rooli === KirjanpitajanRooli.SUPER || kirjautunutKayttaja.rooli === KirjanpitajanRooli.TAVALLINEN_JA_HOLVI)) {
          return true
        }
        return false
      }),
    )

    this.naytaTyolistaObservable = this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable.pipe(
      switchMap(tiedot => {
        if (!tiedot?.uid) {
          return observableOf<boolean>(false)
        }
        if (tiedot.rooli === KirjanpitajanRooli.SUPER) {
          return observableOf<boolean>(true)
        }
        const vastuu = this._firebaseLemonator.firestoreCollectionGroup<ListausAsiakas>('asiakaslistaus').where('p', '==', tiedot.uid).where('lista', '==', 'tyolista').limit(1).listen()
        const vara = this._firebaseLemonator.firestoreCollectionGroup<ListausAsiakas>('asiakaslistaus').where('s', '==', tiedot.uid).where('lista', '==', 'tyolista').limit(1).listen()
        return combineLatest([vastuu, vara]).pipe(map(([p, s]) => !!p?.length || !!s?.length))
      }),
    )

    this.naytaTyolistaFivaldiObservable = this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable.pipe(
      switchMap(tiedot => {
        if (!tiedot?.uid) {
          return observableOf<boolean>(false)
        }
        if (tiedot.rooli === KirjanpitajanRooli.SUPER) {
          return observableOf<boolean>(true)
        }
        const vastuu = this._firebaseLemonator.firestoreCollectionGroup<ListausAsiakas>('asiakaslistaus').where('p', '==', tiedot.uid).where('lista', '==', 'fivaldi').limit(1).listen()
        const vara = this._firebaseLemonator.firestoreCollectionGroup<ListausAsiakas>('asiakaslistaus').where('s', '==', tiedot.uid).where('lista', '==', 'fivaldi').limit(1).listen()
        return combineLatest([vastuu, vara]).pipe(map(([p, s]) => !!p?.length || !!s?.length))
      }),
    )

    this.naytaTyolistaKasvuObservable = this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable.pipe(
      switchMap(tiedot => {
        if (!tiedot?.uid) {
          return observableOf<boolean>(false)
        }
        if (tiedot.rooli === KirjanpitajanRooli.SUPER) {
          return observableOf<boolean>(true)
        }
        const vastuu = this._firebaseLemonator.firestoreCollectionGroup<ListausAsiakas>('asiakaslistaus').where('p', '==', tiedot.uid).where('lista', '==', 'kasvu').limit(1).listen()
        const vara = this._firebaseLemonator.firestoreCollectionGroup<ListausAsiakas>('asiakaslistaus').where('s', '==', tiedot.uid).where('lista', '==', 'kasvu').limit(1).listen()
        return combineLatest([vastuu, vara]).pipe(map(([p, s]) => !!p?.length || !!s?.length))
      }),
    )

    this.naytaItTyopoytaObservable = this._kirjautunutKayttajaService.kirjanpitajaOnDevaajaTaiTukiObservable.pipe(
      switchMap(onkoItTiiminJasen => {
        if (!onkoItTiiminJasen) {
          return observableOf<boolean>(false)
        }

        // const anythingInLemonatorObservable = this._firebaseLemonator.firestoreCollection<any>('tyojono/')
        //   .where('__name__', 'not-in', ['holvi'])
        //   .limit(1).listen().pipe(map(resp => !!resp.length))
        // const anythingInLemonaidObservable = this._firebaseLemonaid.firestoreCollection<any>('tyojono/')
        //   .where('__name__', 'not-in', ['viia', 'enable-banking'])
        //   .limit(1).listen().pipe(map(resp => !!resp.length))

        // return combineLatest([anythingInLemonatorObservable, anythingInLemonaidObservable]).pipe(map(([anythingInLemonator, anythingInLemonaid]) => {
        //   return anythingInLemonator || anythingInLemonaid
        // })
        // )
        return observableOf<boolean>(true)
      }),
    )

    this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable.pipe(takeUntil(this._ngUnsubscribe)).subscribe(tiedot => {
      if (tiedot) {
        if (this.lomake.kirjanpitaja().value() !== tiedot.uid) {
          asetaArvo(this.lomake.kirjanpitaja, tiedot.uid)
        }
      } else if (this.lomake.kirjanpitaja().value() !== null) {
        asetaArvo(this.lomake.kirjanpitaja, null)
      }
    })
  }

  ngOnInit() {}

  ngOnDestroy() {
    this._ngUnsubscribe.next()
    this._ngUnsubscribe.complete()
  }

  logout() {
    // this.suljeVasenValikko()
    // this.vasemmanValikonSulkupyyntoOma.emit()
    this._ladataanService.aloitaLataaminen()
    this._kirjautunutKayttajaService
      .logout()
      .then(res => {
        this._router
          .navigate(['/kirjauduttupois'])
          .then(() => {
            this._ladataanService.lopetaLataaminen()
          })
          .catch(err => {
            this._ladataanService.lopetaLataaminen()
            this._errorHandler.handleError(err)
          })
      })
      .catch(err => {
        this._ladataanService.lopetaLataaminen()
        this._errorHandler.handleError(err)
      })
  }

  vaihdaKieli() {
    const data: VaihdaKieliDialogData = {
      tallenna: true,
    }
    this._dialog.open(VaihdaKieliDialog, { data: data })
  }

  async vaihdaAlavalikko(valittu: LemonatorAlavalikko | 'koti') {
    this.valittuAlavalikko = valittu
    if (this.nykyinenAsiakas) {
      if (valittu === 'koti') {
        this._router.navigate(['asiakkaat'])
        return
      }
      const reitti = await this._nakymaOikeusService.annaEnsimmainenSallittuReittiRyhmalle(valittu)
      if (reitti) {
        this._router.navigate(['asiakkaat', this.nykyinenAsiakas.avain, ...reitti])
      }
    }
  }

  async avaaYllapito() {
    this._asiakasService.asetaNykyinenAsiakas(null)

    const [naytaYber, naytaMassamuikkarit] = await Promise.all([firstValueFrom(this.naytaYllapitoYberObservable), firstValueFrom(this.naytaYllapitoMassamuikkaritObservable)])
    if (naytaYber) {
      this._router.navigate(['/yllapito/integraatiot-verohallinto'])
    } else if (naytaMassamuikkarit) {
      this._router.navigate(['/yllapito/massamuikkarit'])
    } else {
      this._router.navigate(['/yllapito/raportit'])
    }
  }

  avaaTettranVersiohistoria() {
    window.open('https://app.tettra.co/teams/lemontree/pages/lemonator-ja-lemonaid-muutoshistoria', '_blank')
  }

  // avaaVersiohistoria() {
  //   this._dialog.open(ChangelogDialog)
  // }

  clickKotiin() {
    firstValueFrom(this._asiakasService.nykyinenAsiakasObservable).then(asiakas => {
      if (asiakas) {
        const vastuu = this._asiakasJaettuService.annaNykyinenVastuukirjanpitaja(asiakas)
        if (vastuu && vastuu.kirjanpitajanAvain === 'QgPvtcCjoOdf6Zg7lgMwqLWp2BG2') {
          this._router.navigate(['zen'])
          return
        }
        const palvelupaketti = this._sopimuskausiService.annaPalvelupakettiPaivalle(asiakas.sopimuskaudet, this._dateService.currentLocalDate())
        if (palvelupaketti === SopimusPalvelupaketti.KASVU_SUORITEPERUSTEINEN) {
          this._router.navigate(['asiakkaat', 'kasvu'])
          return
        }
        if (!asiakas.uudessaListassa) {
          this._router.navigate(['asiakkaat', 'fivaldi'])
          return
        }
      }
      this._router.navigate(['asiakkaat'])
    })
  }

  navigateToTyojonoLatausDetails() {
    this._router.navigate(['asiakkaat', this.nykyinenAsiakas.avain, 'lataus-tyot'])
  }

  toggleNaytaPoistuneetKirjanpitajat() {
    this.naytaPoistuneetKirjanpitajatSubject.next(!this.naytaPoistuneetKirjanpitajatSubject.value)
  }
}
